module.exports = __webpack_public_path__ + "static/img/new_ssq.93cdab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_ssq.png
// module id = vx9z
// module chunks = 101